export default function initCopyToClipboard() {
  Alpine.data('copyToClipboard', () => ({
    copied: false,
    clickToCopy(event: Event) {
      const element = event.target as Element;

      const messageTarget = element?.querySelector<HTMLElement>('.message-text') ?? null;

      const textToCopy = element.getAttribute('data-text') ?? '';
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy);
      }
      if (messageTarget) {
        this.copied = true;
        const self = this;
        setTimeout(() => {
          self.copied = false;
        }, 3000);
      }
    },
  }));
}
